import { render, staticRenderFns } from "./RatingUpdate.vue?vue&type=template&id=2dba8244&"
import script from "./RatingUpdate.vue?vue&type=script&lang=js&"
export * from "./RatingUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports